/* ======= Slider start ======= */
jQuery(document).ready(function ($) {
  window.addEventListener("load", function () {
    // Advance the slider via its own "next" arrow control instead of
    // guessing at global <a> tag positions on the page. The previous
    // version grabbed document.getElementsByTagName("a")[7, 8, 9] hoping
    // to land on the slider's own pagination links, but that only holds
    // up if no other <a> tags exist earlier in the page — any header/nav
    // change shifts those indices onto unrelated links (the search icon,
    // category cards, etc.), stripping their href and firing clicks on
    // the wrong elements sitewide instead of advancing the slide. The
    // .next arrow is a plain <div> that always sits in the same place
    // relative to the slider, so clicking it can't touch anything else
    // on the page.
    const nextButton = document.querySelector(
      ".super-simple-slider-container .next"
    );
    const slideInterval = 5000;

    if (!nextButton) {
      return;
    }

    setInterval(function () {
      nextButton.click();
    }, slideInterval);
  });
});
